module.exports = __webpack_public_path__ + "img/ClownofBuckets.a09be393.png";